import React from "react";

const EmployeeTransport = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}

<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Employee Transport Solutions</h1>
          </div>
        </div>
      </section>


  

      {/* ===== CONTENT ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-md-6 mb-4">
              <img
                src="/images/gallery/01.jpeg"
                alt="Employee Transport Services Pune"
                className="img-fluid rounded shadow"
              />
            </div>

            <div className="col-md-6">
              <h2>
                <span className="text-danger">Employee</span> Transport Solutions
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. provides safe, reliable,
                and scalable employee transportation solutions for IT parks,
                corporate offices, BPOs, and industrial organizations.
              </p>

              <p>
                Our employee transport services are designed with a strong
                emphasis on punctuality, safety, route optimization, and
                operational efficiency. We support organizations in managing
                daily office commutes and shift-based transportation seamlessly.
              </p>

              <h5 className="mt-4">Key Features</h5>
              <ul className="list-unstyled">
                <li>✔ GPS-enabled & monitored vehicles</li>
                <li>✔ Background-verified drivers</li>
                <li>✔ Shift-based pickup & drop services</li>
                <li>✔ Women safety compliance</li>
                <li>✔ Centralized control & reporting</li>
              </ul>

              <p>
                Our structured processes ensure employee safety while helping
                organizations reduce transportation complexities.
              </p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default EmployeeTransport;
